import { SampleTable } from "@/shared/components/ui";
import { useGetPreventas } from "@/shared/actions/erp";
import { useCheckPermissions, useTableColumnsPreventa } from "@/shared/hooks";
import { Button, Grid } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { useState } from "react";
import { IDataPreventa } from "@/shared/interfaces";
import { PermissionsEnum } from "@/auth/interfaces";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { EstadoPreventaEnum } from "@/shared";

type InfoPreventaProps = {
  codigo: string
}
export default function InfoPreventa({
  codigo
}: InfoPreventaProps) {
  useCheckPermissions(PermissionsEnum.api_view_preventa);

  const { columnsPreventa } = useTableColumnsPreventa(EstadoPreventaEnum.FINALIZADO);

  const [open, setOpen] = useState(false);
  const [enabled, setEnabled] = useState(false);

  const { isLoading, data: preventaResp,
  } = useGetPreventas({
    page: 1,
    page_size: 1,
    codigo
  }, enabled);


  return (
    <>
      <Button
        color="primary"
        startIcon={<OpenInNew />}
        onClick={() => {
          setOpen(true)
          setEnabled(true)
        }}
      >
        VER
      </Button>

      {
        open && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="Preventa"
            minWidth="75%"
            contentNode={
              <Grid container spacing={2}>

                <Grid item xs={12}>
                  <SampleTable<IDataPreventa>
                    isLoading={isLoading}
                    data={preventaResp?.data.data || []}
                    columns={columnsPreventa}
                    enablePagination
                  />
                </Grid>
              </Grid>
            }
          />
        )
      }
    </>
  );



}